module.exports = __webpack_public_path__ + "img/undraw_design_components_9vy6 (1).54cdd45e.svg";